import { render, staticRenderFns } from "./dataConfig.vue?vue&type=template&id=72ec34f9"
import script from "./dataConfig.vue?vue&type=script&lang=js"
export * from "./dataConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72ec34f9')) {
      api.createRecord('72ec34f9', component.options)
    } else {
      api.reload('72ec34f9', component.options)
    }
    module.hot.accept("./dataConfig.vue?vue&type=template&id=72ec34f9", function () {
      api.rerender('72ec34f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Nutrition/baseData/dataConfig.vue"
export default component.exports